import { render, staticRenderFns } from "./OfferConfirmationDiscount.vue?vue&type=template&id=5ce652fc&"
import script from "./OfferConfirmationDiscount.vue?vue&type=script&lang=js&"
export * from "./OfferConfirmationDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports